import Vue from 'vue'

export const updatePassword = params => {
  return Vue.http.post('/virus/account/updatePassword', params)
}

export const phoneUpdatePassword = params => {
  return Vue.http.post('/virus/account/phoneUpdatePassword', params)
}

export const setNewEmail = params => {
  return Vue.http.post('/virus/account/setNewEmail', params)
}

export const phoneSetNewEmail = params => {
  return Vue.http.post('/virus/account/phoneSetNewEmail', params)
}

export const queryCertificationInfo = params => {
  return Vue.http.post('/virus/account/queryCertificationInfo', params)
}

export const personalCertification = params => {
  return Vue.http.post('/virus/account/personalCertification', params)
}

export const enterpriseCertification = params => {
  return Vue.http.post('/virus/account/enterpriseCertification', params)
}

export const queryAuditInfo = params => {
  return Vue.http.post('/virus/account/queryAuditInfo', params)
}

export const getBasicInfo = params => {
  return Vue.http.get('/virus/account/getBasicInfo', {
    params
  })
}

export const updateBasicInfo = params => {
  return Vue.http.post('/virus/account/updateBasicInfo', params)
}

export const queryAccount = params => {
  return Vue.http.post('/virus/account/queryAccount', params)
}

export const getPersonalInfo = params => {
  return Vue.http.post('/virus/account/getPersonalInfo', params)
}
